import React, { Component } from 'react';
/**
* This component is used to get an image with count.
*/
import ImgIconComp from './imgcomp';

class IconCountComp extends React.Component {
  // getDefaultProps is deprecated and the right way to get default props is
  // to use a static method.
  static get defaultProps() {
    return {
      count: 0,
      iconPath: '',
      hideNone: 1,
      imgWidth: 10,
      imgHeight: 10,
      imgPadding: '2px',
      flexOrInlineStyle: 'divInlineBlock',
      useFlex: false,
    };
  }

  constructor(props) {
    super(props);
  }

  getCount() {
    return (typeof this.props.count && this.props.count > 0) ? this.props.count : 0;
  }

  render() {
    const count = this.getCount();
    const { imgWidth } = this.props;
    const { imgHeight } = this.props;
    if (this.props.hideNone && count == 0) {
      return null;
    }
    return (
      <div className={`iconcountcomp-wrapper ${this.props.useFlex ? this.props.flexOrInlineStyle : ''}`}>
        <div className={`iconcountcomp-counttext ${!this.props.useFlex ? this.props.flexOrInlineStyle : ''}`}>
          <div>{count}</div>
        </div>
        <div className="iconcountcomp-icon divInlineBlock" style={{ padding: this.props.imgPadding }}>
          {typeof this.props.iconPath === 'function'
            ? this.props.iconPath({ width: imgWidth, height: imgHeight })
            : <ImgIconComp id={this.props.iconPath} width={imgWidth} height={imgHeight} />
          }
        </div>
        <div className="clear" />
      </div>
    );
  }
}

export default IconCountComp;
